export const ACTION_SET_CONTRACT = "SET_CONTRACT";
